import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';

const initialState: DashboardState = {
    clients: [],
    viewing_client: undefined,
    consultants: [],
    viewing_consultant: undefined,
};

const rootState: DashboardState = initialState;

const getters: GetterTree<DashboardState, RootState> = {
    clients(state: DashboardState): Client[] | undefined {
        return state.clients;
    },
    viewingClient(state: DashboardState): Client | undefined {
        return state.viewing_client;
    },
    consultants(state: DashboardState): Consultant[] | undefined {
        return state.consultants;
    },
    viewingConsultant(state: DashboardState): Consultant | undefined {
        return state.viewing_consultant;
    },
};

const mutations: MutationTree<DashboardState> = {
    RESET(state: DashboardState) {
        state.clients = [];
        state.viewing_client = undefined;
        state.consultants = [];
        state.viewing_consultant = undefined;
    },
    ADD_CLIENTS(state: DashboardState, payload: Client[]) {
        if (state.clients) {
            state.clients = [...state.clients, ...payload];
        } else {
            state.clients = payload;
        }
    },
    SET_CLIENTS(state: DashboardState, payload: Client[]) {
        state.clients = payload;
    },
    SET_VIEWING_CLIENT(state: DashboardState, payload: Client) {
        state.viewing_client = payload;
    },
    SET_CONSULTANTS(state: DashboardState, payload: Consultant[]) {
        state.consultants = payload;
    },
    SET_VIEWING_CONSULTANT(state: DashboardState, payload: Consultant) {
        state.viewing_consultant = payload;
    },
};

const actions: ActionTree<DashboardState, RootState> = {
    readClient({ commit }, payload: { client_id: number }): any {
        // @ts-ignore
        return this._vm.$api.get(`dashboard-users/${payload.client_id}`, { withCredentials: true })
            .then((response: { data: Client }) => {
                commit('SET_VIEWING_CLIENT', response.data);

                return Promise.resolve(response.data);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
    indexClients({ commit }, payload?: IndexPayload): any {
        // @ts-ignore
        return this._vm.$api.get(`dashboard-users`, { params: payload, withCredentials: true })
            .then((response: { data: Client[] }) => {
                if (payload && payload.hasOwnProperty('after')) {
                    commit('ADD_CLIENTS', response.data);
                } else {
                    commit('SET_CLIENTS', response.data);
                }

                return Promise.resolve(response.data);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
    readConsultants({ commit }): any {
        // @ts-ignore
        return this._vm.$api.get(`dashboard-consultants`, { withCredentials: true })
            .then((response: { data: Consultant[] }) => {
                commit('SET_CONSULTANTS', response.data);

                return Promise.resolve(response.data);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
    readConsultant({ commit }, payload: { consultant_id: number }): any {
        // @ts-ignore
        return this._vm.$api.get(`dashboard-consultants/${payload.consultant_id}`, { withCredentials: true })
            .then((response: { data: Client }) => {
                commit('SET_VIEWING_CONSULTANT', response.data);

                return Promise.resolve(response.data);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
};

export default {
    namespaced: true,
    state: rootState,
    getters,
    actions,
    mutations,
};
